module.exports = __webpack_public_path__ + "static/media/profile-1.3d83569d.png";